import React, { Component } from 'react';
import axios from 'axios';
import DatePicker from "react-date-picker";

import {
  POST_AD
} from '../../config';
import Header from '../../components/Header/Header';

import {
          ONE_DAY,
          SUBMIT_SUCCESS,
          SUBMIT_ERROR
       } from './constants';

class Ads extends Component {
  constructor(props){
    super(props);
    if(!this.props.client){
      this.props.updateClient();
    }
    this.state = {
      restaurant: null,
      credits: null,
      itemVal: "",
      startDate: this.addDays(new Date(), 2),
      endDate: this.addDays(new Date(), 3),
      city: "",
      submitting: false,
      submitSuccess: false
    }
    this.handleStartDate = this.handleStartDate.bind(this);
    this.handleEndDate = this.handleEndDate.bind(this);
  }

  get header(){
    return(
      <Header
        pageName="Advertise with Honeycomb"
      />
    )
  }

  get credits(){
    return(
      <div className="row">
        <div className="dashboardCard">
          <div className="dashboardCardBody">
              <h5 className="dashboardCardHeading"> Discovery Credits </h5>
              {this.getCredits()}
              <p>You can use discovery credits to advertise with Honeycomb. One discovery credit is worth one day of advertisement on our app.</p>
              <p>The item you advertise will be promoted with Honeycomb's intelligent ability to target users by dietary restriction. This promoted item will only be visible to users who have indicated in their dietary profile that the ingredients in this item are suitable for them.</p>
              {this.creditCount()}
          </div>
        </div>
      </div>
    )
  }

  creditCount() {
    return(
      <h5 className="card-title"> You have <span style={{color: "#1C7DF7"}}>{this.state.credits}</span> discovery credits! </h5>
    )
  }

  getCredits() {
    if(this.state.credits == null && this.props.client != null) {
      this.setState({credits: this.props.client.discoveryCredits})
    }
  }

  get chooseDay() {
    return(
      <div className="row">
        <div className="dashboardCard">
          <div className="dashboardCardBody">
            <h5 className="card-title"> Time Period </h5>
            <div id="datePickerBody">
            <div className="datePicker">
              <p>Choose your starting date</p>
              <DatePicker
                value={this.state.startDate}
                onChange={this.handleStartDate}
                minDate={this.addDays(new Date(), 2)}
              />
            </div>
            <div className="datePicker">
              <p>Choose your ending date</p>
              <DatePicker
                value={this.state.endDate}
                onChange={this.handleEndDate}
                minDate={this.addDays(new Date(), 3)}
              />
            </div>
            </div>
            {this.creditsLeft()}
          </div>
        </div>
      </div>
    )
  }

  handleStartDate(date) {
    this.setState({
      startDate: date
    });
  }

  handleEndDate(date) {
    this.setState({
      endDate: date
    });
  }

  addDays(date, days) {
    const copy = new Date(Number(date))
    copy.setDate(date.getDate() + days)
    return copy
  }

  creditsLeft() {
    var dateDiff = null;
    if(this.state.endDate == null || this.state.startDate == null){
      dateDiff = null;
    }
    else dateDiff = Math.round((this.state.endDate.getTime() - this.state.startDate.getTime())/(ONE_DAY));

    if (dateDiff <= 0) {
      return (<p style={{color: '#F84835'}}>{"The starting date must be at least one day before the ending date."}</p>)
    }
    else if (dateDiff > this.state.credits) {
      return (<p style={{color: '#F84835'}}>{"You do not have enough credits to choose this date range."}</p>)
    }
    else return (<p>{"You have "+(this.state.credits - dateDiff)+" credits remaining after posting this ad."}</p>)
  }

  get inputItem() {
    return(
      <div className="row">
        <div className="dashboardCard">
          <div className="dashboardCardBody">
              <h5 className="card-title"> Item </h5>
              <input
                  type="text"
                  placeholder="Enter the name of the item you would like to advertise"
                  className="form-control short-text-input"
                  value={this.state.itemVal}
                  onChange={(event) => this.setState({itemVal: event.target.value})}
              />
          </div>
        </div>
      </div>
    )
  }

  get enterCity(){
    return(
      <div className="row">
        <div className="dashboardCard">
          <div className="dashboardCardBody">
          <h5 className="card-title"> Location </h5>
          <input
              type="text"
              placeholder="Enter the city you are advertising to"
              className="form-control short-text-input"
              value={this.state.city}
              onChange={(event) => this.setState({ city: event.target.value })}
          />
          </div>
        </div>
      </div>
    )
  }

  get submitMsg() {
    return (
      <div className="RegistrationCard" id={this.state.submitSuccess ? "ErrorGreen" : "ErrorRed"}>
        <div className="RegistrationCardBody">
        {this.state.submitSuccess ? SUBMIT_SUCCESS : SUBMIT_ERROR}
        </div>
      </div>
    )
  }

  get submitBtn() {
    return (
      <button
        onClick={() => this.submitAd()}
        className="honeycombButton"
      >
        Submit Ad
      </button>
    )
  }

  submitAd() {
    {this.setState({submitting: true})}
    var dateDiff = Math.round((this.state.endDate.getTime() - this.state.startDate.getTime())/(ONE_DAY));

    if (dateDiff < 0 || dateDiff > this.state.credits || this.state.itemVal == "" || this.state.city == "") {
      this.setState({submitSuccess: false})
      return;
    }
    this.setState({credits: this.state.credits-dateDiff})

    let JSONObj = {
      "name": this.props.client.email,
      "creditsUsed": dateDiff,
      "startDate": this.state.startDate,
      "endDate": this.state.endDate,
      "city": this.state.city,
      "item": this.state.itemVal
      }

    axios.post(
      POST_AD(),
      {"name": this.props.client.email,
      "creditsUsed": dateDiff,
      "startDate": this.state.startDate,
      "endDate": this.state.endDate,
      "city": this.state.city,
      "item": this.state.itemVal},
      {
        headers: {
          "Authorization": this.props.client.token,
          "Content-Type": "application/json"
        }
      }
    ).then(function(response){
      self.props.updateClient();
    })
    .catch(function(err){
    })

    this.setState({submitSuccess: true})
  }

  render() {
    return (
      <div className="animated fadeIn">
        {this.header}
        <div className="pageContainer">
        {this.credits}
        {this.chooseDay}
        {this.inputItem}
        {this.enterCity}
        {this.submitBtn}
        {this.state.submitting ? this.submitMsg : null}
        </div>
      </div>
    )
  }
}

export default Ads;



// WEBPACK FOOTER //
// ./src/views/Ads/Ads.js